var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.dismiss
    ? _c(
        "div",
        {
          staticClass:
            "bg-primary d-flex justify-content-center text-white w-100 fixed-to-top",
          attrs: { id: "not-recommended-browser" },
        },
        [
          _c("div", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("global.phrases.notRecommendedBrowser")) +
                "\n    "
            ),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://www.google.com/intl/es_ALL/chrome/",
                },
              },
              [
                _c("icon", {
                  staticClass: "white-text p-3",
                  attrs: { name: "chrome" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://www.mozilla.org/en-US/firefox/new/",
                },
              },
              [
                _c("icon", {
                  staticClass: "white-text p-3",
                  attrs: { name: "firefox" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { target: "_blank", href: "https://www.opera.com" } },
              [
                _c("icon", {
                  staticClass: "white-text p-3",
                  attrs: { name: "opera" },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "position-absolute d-flex align-items-center justify-content-center",
              staticStyle: { right: "0", height: "100%" },
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "clickable dismiss-not-recommended mr-4 my-auto bold",
                  on: { click: _vm.handleDismiss },
                },
                [_c("icon", { attrs: { name: "times" } })],
                1
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }